<app-nav-steps *ngIf="showNavSteps && !isDetailsView"></app-nav-steps>
<ng-container *ngIf="!environmentService.isDecommissioningOfGridConnection || currentSelectionType !== 'shutdown'">
  <div class="component-container">
    <div class="form-font-size">
      <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
        <app-review-section
          #documentsSection
          *ngIf="applicationData"
          [applicationId]="applicationData?.application_id"
          [sectionId]="SectionIdentifier.Document_Submission"
          [title]="'app.navigation.doc_upload' | translate | uppercase"
          [tooltip]="'tooltips.documents-submission.document-header-info' | translate"
          [showTooltip]="environmentService.showDocumentHeaderHintIcon && currentInstallationFlow === installationFlowType.MainsConnection"
          [isDetailsView]="isDetailsView">
          <div
            [formGroup]="documents"
            *ngIf="documents || this.isGridCompatibility"
            class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12">
            <div class="form-background top-bottom-margin" *ngIf="currentInstallationFlow === installationFlowType.FeedInSystem">
              <app-document-editor
                *ngIf="documents.get('site_plan')"
                [applicationId]="applicationData?.application_id"
                [form]="documents"
                controlName="site_plan"
                [label]="showSitePlanLabel ? ('documents.site-plan' | translate) : ('documents.official-plan' | translate)"
                [documentId]="documentIds['site_plan']"
                [documentType]="'site_plan'"
                [isReadOnly]="isDetailsView && !documentsSection.isDataEditable"
                (update)="onDocumentUpdated($event)"></app-document-editor>
              <div *ngIf="documents.get('site_plan') && allSampleDocuments?.site_plan" class="ui-g-12 sample-doc-link">
                <label class="ui-g-3"></label>
                <span class="sample-label">{{ 'documents.sample-label' | translate }}:</span>
                <a (click)="downloadExampleDocument(allSampleDocuments['site_plan'].document_id, allSampleDocuments['site_plan'].filename)">
                  {{ allSampleDocuments['site_plan'].name }}
                </a>
              </div>
              <app-document-editor
                *ngIf="documents.get('unit_certificate')"
                [applicationId]="applicationData?.application_id"
                [form]="documents"
                controlName="unit_certificate"
                [label]="'documents.unit-certificate' | translate"
                [documentId]="documentIds['unit_certificate']"
                [documentType]="'unit_certificate'"
                [isReadOnly]="isDetailsView && !documentsSection.isDataEditable"
                (update)="onDocumentUpdated($event)"></app-document-editor>
              <div *ngIf="allSampleDocuments?.unit_certificate" class="ui-g-12 sample-doc-link">
                <label class="ui-g-3"></label>
                <span class="sample-label">{{ 'documents.sample-label' | translate }}:</span>
                <a
                  (click)="
                    downloadExampleDocument(
                      allSampleDocuments['unit_certificate'].document_id,
                      allSampleDocuments['unit_certificate'].filename
                    )
                  ">
                  {{ allSampleDocuments['unit_certificate'].name }}
                </a>
              </div>
              <app-document-editor
                *ngIf="documents.get('na_protection_certificate')"
                [applicationId]="applicationData?.application_id"
                [form]="documents"
                controlName="na_protection_certificate"
                [label]="'documents.protection-certificate' | translate"
                [documentId]="documentIds['na_protection_certificate']"
                [documentType]="'na_protection_certificate'"
                [isReadOnly]="isDetailsView && !documentsSection.isDataEditable"
                (update)="onDocumentUpdated($event)"></app-document-editor>
              <div *ngIf="allSampleDocuments?.na_protection_certificate" class="ui-g-12 sample-doc-link">
                <label class="ui-g-3"></label>
                <span class="sample-label">{{ 'documents.sample-label' | translate }}:</span>
                <a
                  (click)="
                    downloadExampleDocument(
                      allSampleDocuments['na_protection_certificate'].document_id,
                      allSampleDocuments['na_protection_certificate'].name
                    )
                  ">
                  {{ allSampleDocuments['na_protection_certificate'].filename }}
                </a>
              </div>

              <app-document-editor
                *ngIf="documents.get('vde_documents')"
                [applicationId]="applicationData?.application_id"
                [form]="documents"
                controlName="vde_documents"
                [label]="'documents.vde-document' | translate"
                [documentId]="documentIds['vde_documents']"
                documentType="vde_documents"
                [isReadOnly]="isDetailsView && !documentsSection.isDataEditable"
                (update)="onDocumentUpdated($event)"></app-document-editor>
              <div *ngIf="allSampleDocuments?.vde_documents" class="ui-g-12 sample-doc-link">
                <label class="ui-g-3"></label>
                <span class="sample-label">{{ 'documents.sample-label' | translate }}:</span>
                <a
                  (click)="
                    downloadExampleDocument(allSampleDocuments['vde_documents'].document_id, allSampleDocuments['vde_documents'].filename)
                  ">
                  {{ allSampleDocuments['vde_documents'].name }}
                </a>
              </div>

              <app-document-editor
                *ngIf="documents.get('data_sheet_modules')"
                [applicationId]="applicationData?.application_id"
                [form]="documents"
                controlName="data_sheet_modules"
                [label]="'documents.manufacturer-sheets' | translate"
                [documentId]="documentIds['data_sheet_modules']"
                documentType="data_sheet_modules"
                [isReadOnly]="isDetailsView && !documentsSection.isDataEditable"
                (update)="onDocumentUpdated($event)"></app-document-editor>
              <div *ngIf="allSampleDocuments?.data_sheet_modules" class="ui-g-12 sample-doc-link">
                <label class="ui-g-3"></label>
                <span class="sample-label">{{ 'documents.sample-label' | translate }}:</span>
                <a
                  (click)="
                    downloadExampleDocument(
                      allSampleDocuments['data_sheet_modules'].document_id,
                      allSampleDocuments['data_sheet_modules'].filename
                    )
                  ">
                  {{ allSampleDocuments['data_sheet_modules'].name }}
                </a>
              </div>

              <app-document-editor
                *ngIf="documents.get('data_sheet_generating_unit')"
                [applicationId]="applicationData?.application_id"
                [form]="documents"
                controlName="data_sheet_generating_unit"
                [label]="'documents.manufacturer-generation-sheet' | translate"
                [documentId]="documentIds['data_sheet_generating_unit']"
                documentType="data_sheet_generating_unit"
                [isReadOnly]="isDetailsView && !documentsSection.isDataEditable"
                (update)="onDocumentUpdated($event)"></app-document-editor>
              <div *ngIf="allSampleDocuments?.data_sheet_generating_unit" class="ui-g-12 sample-doc-link">
                <label class="ui-g-3"></label>
                <span class="sample-label">{{ 'documents.sample-label' | translate }}:</span>
                <a
                  (click)="
                    downloadExampleDocument(
                      allSampleDocuments['data_sheet_generating_unit'].document_id,
                      allSampleDocuments['data_sheet_generating_unit'].filename
                    )
                  ">
                  {{ allSampleDocuments['data_sheet_generating_unit'].name }}
                </a>
              </div>

              <app-document-editor
                *ngIf="documents.get('overview_plan_single_pole')"
                [applicationId]="applicationData?.application_id"
                [form]="documents"
                controlName="overview_plan_single_pole"
                [label]="'documents.single-pole-overview-plan' | translate"
                [documentId]="documentIds['overview_plan_single_pole']"
                documentType="overview_plan_single_pole"
                [isReadOnly]="isDetailsView && !documentsSection.isDataEditable"
                (update)="onDocumentUpdated($event)"></app-document-editor>
              <div *ngIf="allSampleDocuments?.overview_plan_single_pole" class="ui-g-12 sample-doc-link">
                <label class="ui-g-3"></label>
                <span class="sample-label">{{ 'documents.sample-label' | translate }}:</span>
                <a
                  (click)="
                    downloadExampleDocument(
                      allSampleDocuments['overview_plan_single_pole'].document_id,
                      allSampleDocuments['overview_plan_single_pole'].filename
                    )
                  ">
                  {{ allSampleDocuments['overview_plan_single_pole'].name }}
                </a>
              </div>

              <app-document-editor
                *ngIf="documents.get('pole_circuit_diagram_1')"
                [applicationId]="applicationData?.application_id"
                [form]="documents"
                controlName="pole_circuit_diagram_1"
                [label]="'lookup.' + documentTypeKey + '.options.pole_circuit_diagram_1.name' | translate"
                [documentId]="documentIds['pole_circuit_diagram_1']"
                documentType="pole_circuit_diagram_1"
                [isReadOnly]="isDetailsView && !documentsSection.isDataEditable"
                (update)="onDocumentUpdated($event)"></app-document-editor>

              <!-- power_of_attorney_1 -->
              <app-document-editor
                *ngIf="documents.get('power_of_attorney_1')"
                [applicationId]="applicationData?.application_id"
                [form]="documents"
                controlName="power_of_attorney_1"
                [label]="'documents.power_of_attorney_1' | translate"
                [documentId]="documentIds['power_of_attorney_1']"
                documentType="power_of_attorney_1"
                [isReadOnly]="isDetailsView && !documentsSection.isDataEditable"
                (update)="onDocumentUpdated($event)"
                [tooltip]="'documents.power_of_attorney_1_info' | translate"></app-document-editor>

              <div *ngIf="allSampleDocuments?.power_of_attorney_1" class="ui-g-12 sample-doc-link">
                <label class="ui-g-3"></label>
                <span class="sample-label">{{ 'documents.sample-label' | translate }}:</span>
                <a
                  (click)="
                    downloadExampleDocument(
                      allSampleDocuments['power_of_attorney_1'].document_id,
                      allSampleDocuments['power_of_attorney_1'].filename
                    )
                  ">
                  {{ allSampleDocuments['power_of_attorney_1'].name }}
                </a>
              </div>

              <!-- e_1_application -->
              <app-document-editor
                *ngIf="documents.get('e_1_application')"
                [applicationId]="applicationData?.application_id"
                [form]="documents"
                controlName="e_1_application"
                [label]="'documents.e_1_application' | translate"
                [documentId]="documentIds['e_1_application']"
                documentType="e_1_application"
                [isReadOnly]="isDetailsView && !documentsSection.isDataEditable"
                (update)="onDocumentUpdated($event)"
                [tooltip]="'documents.e_1_application_info' | translate"></app-document-editor>

              <!-- e_2_data_sheet -->
              <app-document-editor
                *ngIf="documents.get('e_2_data_sheet')"
                [applicationId]="applicationData?.application_id"
                [form]="documents"
                controlName="e_2_data_sheet"
                [label]="'documents.e_2_data_sheet' | translate"
                [documentId]="documentIds['e_2_data_sheet']"
                documentType="e_2_data_sheet"
                [isReadOnly]="isDetailsView && !documentsSection.isDataEditable"
                [tooltip]="'documents.e_2_data_sheet_info' | translate"
                (update)="onDocumentUpdated($event)"></app-document-editor>

              <!-- e_3_memory_data -->
              <app-document-editor
                *ngIf="documents.get('e_3_memory_data')"
                [applicationId]="applicationData?.application_id"
                [form]="documents"
                controlName="e_3_memory_data"
                [label]="'documents.e_3_memory_data' | translate"
                [documentId]="documentIds['e_3_memory_data']"
                documentType="e_3_memory_data"
                [isReadOnly]="isDetailsView && !documentsSection.isDataEditable"
                [tooltip]="'documents.e_3_memory_data_info' | translate"
                (update)="onDocumentUpdated($event)"></app-document-editor>

              <!-- e_4_uniform_certificate -->
              <app-document-editor
                *ngIf="documents.get('e_4_uniform_certificate')"
                [applicationId]="applicationData?.application_id"
                [form]="documents"
                controlName="e_4_uniform_certificate"
                [label]="'documents.e_4_uniform_certificate' | translate"
                [documentId]="documentIds['e_4_uniform_certificate']"
                documentType="e_4_uniform_certificate"
                [isReadOnly]="isDetailsView && !documentsSection.isDataEditable"
                [tooltip]="'documents.e_4_uniform_certificate_info' | translate"
                (update)="onDocumentUpdated($event)"></app-document-editor>

              <!-- e_5_test_report -->
              <app-document-editor
                *ngIf="documents.get('e_5_test_report')"
                [applicationId]="applicationData?.application_id"
                [form]="documents"
                controlName="e_5_test_report"
                [label]="'documents.e_5_test_report' | translate"
                [documentId]="documentIds['e_5_test_report']"
                documentType="e_5_test_report"
                [isReadOnly]="isDetailsView && !documentsSection.isDataEditable"
                [tooltip]="'documents.e_5_test_report_info' | translate"
                (update)="onDocumentUpdated($event)"></app-document-editor>

              <!-- e_6_certificate_for_network -->
              <app-document-editor
                *ngIf="documents.get('e_6_certificate_for_network')"
                [applicationId]="applicationData?.application_id"
                [form]="documents"
                controlName="e_6_certificate_for_network"
                [label]="'documents.e_6_certificate_for_network' | translate"
                [documentId]="documentIds['e_6_certificate_for_network']"
                documentType="e_6_certificate_for_network"
                [isReadOnly]="isDetailsView && !documentsSection.isDataEditable"
                [tooltip]="'documents.e_6_certificate_for_network_info' | translate"
                (update)="onDocumentUpdated($event)"></app-document-editor>

              <!-- e_7_requirements_for_test_report -->
              <app-document-editor
                *ngIf="documents.get('e_7_requirements_for_test_report')"
                [applicationId]="applicationData?.application_id"
                [form]="documents"
                controlName="e_7_requirements_for_test_report"
                [label]="'documents.e_7_requirements_for_test_report' | translate"
                [documentId]="documentIds['e_7_requirements_for_test_report']"
                documentType="e_7_requirements_for_test_report"
                [isReadOnly]="isDetailsView && !documentsSection.isDataEditable"
                [tooltip]="'documents.e_7_requirements_for_test_report_info' | translate"
                (update)="onDocumentUpdated($event)"></app-document-editor>

              <!-- e_8_commissioning_protocol -->
              <app-document-editor
                *ngIf="documents.get('e_8_commissioning_protocol')"
                [applicationId]="applicationData?.application_id"
                [form]="documents"
                controlName="e_8_commissioning_protocol"
                [label]="'documents.e_8_commissioning_protocol' | translate"
                [documentId]="documentIds['e_8_commissioning_protocol']"
                documentType="e_8_commissioning_protocol"
                [isReadOnly]="isDetailsView && !documentsSection.isDataEditable"
                [tooltip]="'documents.e_8_commissioning_protocol_info' | translate"
                (update)="onDocumentUpdated($event)"></app-document-editor>

              <!-- b_11_overview_circuit_diagram -->
              <app-document-editor
                *ngIf="documents.get('b_11_overview_circuit_diagram')"
                [applicationId]="applicationData?.application_id"
                [form]="documents"
                controlName="b_11_overview_circuit_diagram"
                [label]="'documents.b_11_overview_circuit_diagram' | translate"
                [documentId]="documentIds['b_11_overview_circuit_diagram']"
                documentType="b_11_overview_circuit_diagram"
                [isReadOnly]="isDetailsView && !documentsSection.isDataEditable"
                [tooltip]="'documents.b_11_overview_circuit_diagram_info' | translate"
                (update)="onDocumentUpdated($event)"></app-document-editor>

              <!-- registration_for_network_connection -->
              <app-document-editor
                *ngIf="documents.get('registration_for_network_connection')"
                [applicationId]="applicationData?.application_id"
                [form]="documents"
                controlName="registration_for_network_connection"
                [label]="'documents.registration_for_network_connection' | translate"
                [documentId]="documentIds['registration_for_network_connection']"
                documentType="registration_for_network_connection"
                [isReadOnly]="isDetailsView && !documentsSection.isDataEditable"
                [tooltip]="'documents.registration_for_network_connection_info' | translate"
                (update)="onDocumentUpdated($event)"></app-document-editor>

              <!-- site_plan_or_area_map -->
              <app-document-editor
                *ngIf="documents.get('site_plan_or_area_map')"
                [applicationId]="applicationData?.application_id"
                [form]="documents"
                controlName="site_plan_or_area_map"
                [label]="'documents.site_plan_or_area_map' | translate"
                [documentId]="documentIds['site_plan_or_area_map']"
                documentType="site_plan_or_area_map"
                [isReadOnly]="isDetailsView && !documentsSection.isDataEditable"
                [tooltip]="'documents.site_plan_or_area_map_info' | translate"
                (update)="onDocumentUpdated($event)"></app-document-editor>

              <!-- proof_of_conformity_certificates_modules -->
              <app-document-editor
                *ngIf="documents.get('proof_of_conformity_certificates_modules')"
                [applicationId]="applicationData?.application_id"
                [form]="documents"
                controlName="proof_of_conformity_certificates_modules"
                [label]="'documents.proof_of_conformity_certificates_modules' | translate"
                [documentId]="documentIds['proof_of_conformity_certificates_modules']"
                documentType="proof_of_conformity_certificates_modules"
                [isReadOnly]="isDetailsView && !documentsSection.isDataEditable"
                [tooltip]="'documents.proof_of_conformity_certificates_modules_info' | translate"
                (update)="onDocumentUpdated($event)"></app-document-editor>

              <!-- proof_of_conformity_certificates_storage -->
              <app-document-editor
                *ngIf="documents.get('proof_of_conformity_certificates_storage')"
                [applicationId]="applicationData?.application_id"
                [form]="documents"
                controlName="proof_of_conformity_certificates_storage"
                [label]="'documents.proof_of_conformity_certificates_storage' | translate"
                [documentId]="documentIds['proof_of_conformity_certificates_storage']"
                documentType="proof_of_conformity_certificates_storage"
                [isReadOnly]="isDetailsView && !documentsSection.isDataEditable"
                [tooltip]="'documents.proof_of_conformity_certificates_storage_info' | translate"
                (update)="onDocumentUpdated($event)"></app-document-editor>

              <!-- ground_protocol -->
              <app-document-editor
                *ngIf="documents.get('ground_protocol')"
                [applicationId]="applicationData?.application_id"
                [form]="documents"
                controlName="ground_protocol"
                [label]="'documents.ground_protocol' | translate"
                [documentId]="documentIds['ground_protocol']"
                documentType="ground_protocol"
                [isReadOnly]="isDetailsView && !documentsSection.isDataEditable"
                [tooltip]="'documents.ground_protocol_info' | translate"
                (update)="onDocumentUpdated($event)"></app-document-editor>

              <!-- measuring_concept -->
              <app-document-editor
                *ngIf="documents.get('measuring_concept')"
                [applicationId]="applicationData?.application_id"
                [form]="documents"
                controlName="measuring_concept"
                [label]="'documents.measuring_concept' | translate"
                [documentId]="documentIds['measuring_concept']"
                documentType="measuring_concept"
                [isReadOnly]="isDetailsView && !documentsSection.isDataEditable"
                [tooltip]="'documents.measuring_concept_info' | translate"
                (update)="onDocumentUpdated($event)"></app-document-editor>

              <div *ngIf="allSampleDocuments && allSampleDocuments['pole_circuit_diagram_1']" class="ui-g-12 sample-doc-link">
                <label class="ui-g-3"></label>
                <span class="sample-label">{{ 'documents.sample-label' | translate }}:</span>
                <a
                  (click)="
                    downloadExampleDocument(
                      allSampleDocuments['pole_circuit_diagram_1'].document_id,
                      allSampleDocuments['pole_circuit_diagram_1'].filename
                    )
                  ">
                  {{ allSampleDocuments['pole_circuit_diagram_1'].name }}
                </a>
              </div>
            </div>
            <div class="form-background top-bottom-margin" *ngIf="isSitePlanDocumentVisible">
              <app-document-editor
                *ngIf="documents.get('site_plan')"
                [applicationId]="applicationData?.application_id"
                [form]="documents"
                controlName="site_plan"
                [label]="'documents.official-plan' | translate"
                [documentId]="documentIds['site_plan']"
                [documentType]="documentTypes[0].value"
                [isReadOnly]="isDetailsView && !documentsSection.isDataEditable"
                (update)="onDocumentUpdated($event)"></app-document-editor>
              <div *ngIf="documents.get('site_plan') && allSampleDocuments?.site_plan" class="ui-g-12 sample-doc-link">
                <label class="ui-g-3"></label>
                <span class="sample-label">{{ 'documents.sample-label' | translate }}:</span>
                <a (click)="downloadExampleDocument(allSampleDocuments['site_plan'].document_id, allSampleDocuments['site_plan'].filename)">
                  {{ allSampleDocuments['site_plan'].name }}
                </a>
              </div>

              <app-document-editor
                *ngIf="
                  documents.get('floor_plan') &&
                  (currentInstallationFlow === installationFlowType.TemporaryConnection ||
                    currentInstallationFlow === installationFlowType.SiteElectricityMeterdata)
                "
                [applicationId]="applicationData?.application_id"
                [form]="documents"
                controlName="floor_plan"
                [label]="floorPlanText | translate"
                [documentId]="documentIds['floor_plan']"
                [documentType]="'floor_plan'"
                [isReadOnly]="isDetailsView && !documentsSection.isDataEditable"
                (update)="onDocumentUpdated($event)"></app-document-editor>

              <app-document-editor
                *ngIf="documents.get('ordonance_clearence')"
                [applicationId]="applicationData?.application_id"
                [form]="documents"
                controlName="ordonance_clearence"
                [label]="'documents.ordnance' | translate"
                [documentId]="documentIds['ordonance_clearence']"
                documentType="ordonance_clearence"
                [isReadOnly]="isDetailsView && !documentsSection.isDataEditable"
                (update)="onDocumentUpdated($event)"></app-document-editor>
              <div
                *ngIf="currentInstallationFlow === installationFlowType.TemporaryConnection && allSampleDocuments?.floor_plan"
                class="ui-g-12 sample-doc-link">
                <label class="ui-g-3"></label>
                <span class="sample-label">{{ 'documents.sample-label' | translate }}:</span>
                <a
                  (click)="
                    downloadExampleDocument(allSampleDocuments['floor_plan'].document_id, allSampleDocuments['floor_plan'].filename)
                  ">
                  {{ allSampleDocuments['floor_plan'].name }}
                </a>
              </div>

              <app-document-editor
                *ngIf="isFloorPlanDocumentVisible && documents.get('floor_plan')"
                [applicationId]="applicationData?.application_id"
                [form]="documents"
                controlName="floor_plan"
                [label]="'documents.plan_with_entry' | translate"
                [documentId]="documentIds['floor_plan']"
                [documentType]="documentTypes[1].value"
                [isReadOnly]="isDetailsView && !documentsSection.isDataEditable"
                (update)="onDocumentUpdated($event)"></app-document-editor>
              <div
                *ngIf="
                  (currentInstallationFlow === installationFlowType.MainsConnection ||
                    currentInstallationFlow === installationFlowType.ChangeHouseConnection) &&
                  allSampleDocuments?.floor_plan
                "
                class="ui-g-12 sample-doc-link">
                <label class="ui-g-3"></label>
                <span class="sample-label">{{ 'documents.sample-label' | translate }}:</span>
                <a
                  (click)="
                    downloadExampleDocument(allSampleDocuments['floor_plan'].document_id, allSampleDocuments['floor_plan'].filename)
                  ">
                  {{ allSampleDocuments['floor_plan'].name }}
                </a>
              </div>

              <app-document-editor
                *ngIf="documents.get('excerpt_or_overview_plan')"
                [applicationId]="applicationData?.application_id"
                [form]="documents"
                controlName="excerpt_or_overview_plan"
                [label]="'documents.excerpt-or-overview-plan' | translate"
                [documentId]="documentIds['excerpt_or_overview_plan']"
                documentType="excerpt_or_overview_plan"
                [isReadOnly]="isDetailsView && !documentsSection.isDataEditable"
                (update)="onDocumentUpdated($event)"></app-document-editor>

              <div
                *ngIf="
                  (currentInstallationFlow === installationFlowType.MainsConnection ||
                    (currentInstallationFlow === installationFlowType.ChangeHouseConnection &&
                      !environmentService.hideExampleOfDocExcerptOrOverviewPlan)) &&
                  allSampleDocuments?.floor_plan
                "
                class="ui-g-12 sample-doc-link">
                <label class="ui-g-3"></label>
                <span class="sample-label">{{ 'documents.sample-label' | translate }}:</span>
                <a
                  (click)="
                    downloadExampleDocument(
                      allSampleDocuments['excerpt_or_overview_plan'].document_id,
                      allSampleDocuments['excerpt_or_overview_plan'].filename
                    )
                  ">
                  {{ allSampleDocuments['excerpt_or_overview_plan'].name }}
                </a>
              </div>

              <app-document-editor
                *ngIf="
                  (currentInstallationFlow === installationFlowType.MainsConnection ||
                    currentInstallationFlow === installationFlowType.ChangeHouseConnection) &&
                  documents?.get('license_agreement')
                "
                [applicationId]="applicationData?.application_id"
                [form]="documents"
                controlName="license_agreement"
                [label]="'lookup.' + documentTypeKey + '.options.license_agreement.name' | translate"
                [documentId]="documentIds['license_agreement']"
                documentType="license_agreement"
                [isReadOnly]="isDetailsView && !documentsSection.isDataEditable"
                (update)="onDocumentUpdated($event)"></app-document-editor>
              <div
                *ngIf="
                  (currentInstallationFlow === installationFlowType.MainsConnection ||
                    currentInstallationFlow === installationFlowType.ChangeHouseConnection) &&
                  allSampleDocuments?.license_agreement &&
                  documents?.get('license_agreement')
                "
                class="ui-g-12 sample-doc-link">
                <label class="ui-g-3"></label>
                <span class="sample-label">{{ 'documents.sample-label' | translate }}:</span>
                <a
                  (click)="
                    downloadExampleDocument(
                      allSampleDocuments['license_agreement'].document_id,
                      allSampleDocuments['license_agreement'].filename
                    )
                  ">
                  {{ allSampleDocuments['license_agreement'].name }}
                </a>
              </div>

              <ng-container *ngIf="documents.get('site_electricity_document')">
                <app-document-editor
                  [applicationId]="applicationData?.application_id"
                  [form]="documents"
                  controlName="site_electricity_document"
                  [label]="'documents.site_electricity_document' | translate"
                  [documentId]="documentIds['site_electricity_document']"
                  documentType="site_electricity_document"
                  [isReadOnly]="isDetailsView && !documentsSection.isDataEditable"
                  (update)="onDocumentUpdated($event)"></app-document-editor>

                <div *ngIf="allSampleDocuments?.floor_plan" class="ui-g-12 sample-doc-link">
                  <label class="ui-g-3"></label>
                  <span class="sample-label">{{ 'documents.sample-label' | translate }}:</span>
                  <a
                    (click)="
                      downloadExampleDocument(allSampleDocuments['floor_plan'].document_id, allSampleDocuments['floor_plan'].filename)
                    ">
                    {{ allSampleDocuments['floor_plan'].name }}
                  </a>
                </div>
              </ng-container>

              <ng-container *ngIf="documents.get('floor_plan_basement')">
                <app-document-editor
                  [applicationId]="applicationData?.application_id"
                  [form]="documents"
                  controlName="floor_plan_basement"
                  [label]="'documents.floor_plan_basement' | translate"
                  [documentId]="documentIds['floor_plan_basement']"
                  documentType="floor_plan_basement"
                  [isReadOnly]="isDetailsView && !documentsSection.isDataEditable"
                  (update)="onDocumentUpdated($event)"></app-document-editor>
                <div *ngIf="allSampleDocuments?.floor_plan_basement" class="ui-g-12 sample-doc-link">
                  <label class="ui-g-3"></label>
                  <span class="sample-label">{{ 'documents.sample-label' | translate }}:</span>
                  <a
                    (click)="
                      downloadExampleDocument(
                        allSampleDocuments['floor_plan_basement'].document_id,
                        allSampleDocuments['floor_plan_basement'].filename
                      )
                    ">
                    {{ allSampleDocuments['floor_plan_basement'].name }}
                  </a>
                </div>
              </ng-container>

              <ng-container *ngIf="documents.get('drinking_water_registration')">
                <app-document-editor
                  [applicationId]="applicationData?.application_id"
                  [form]="documents"
                  controlName="drinking_water_registration"
                  [label]="'documents.water-registry-document' | translate"
                  [documentId]="documentIds['drinking_water_registration']"
                  documentType="drinking_water_registration"
                  [isReadOnly]="isDetailsView && !documentsSection.isDataEditable"
                  (update)="onDocumentUpdated($event)"></app-document-editor>
                <div *ngIf="allSampleDocuments?.drinking_water_registration" class="ui-g-12 sample-doc-link">
                  <label class="ui-g-3"></label>
                  <span class="sample-label">{{ 'documents.sample-label' | translate }}:</span>
                  <a
                    (click)="
                      downloadExampleDocument(
                        allSampleDocuments['drinking_water_registration'].document_id,
                        allSampleDocuments['drinking_water_registration'].filename
                      )
                    ">
                    {{ allSampleDocuments['drinking_water_registration'].name }}
                  </a>
                </div>
              </ng-container>

              <ng-container *ngIf="documents.get('crane_con_with_electric_drive')">
                <app-document-editor
                  [applicationId]="applicationData?.application_id"
                  [form]="documents"
                  controlName="crane_con_with_electric_drive"
                  [label]="'documents.site_electricity_crane_connection_document' | translate"
                  [documentId]="documentIds['crane_con_with_electric_drive']"
                  documentType="crane_con_with_electric_drive"
                  [isReadOnly]="isDetailsView && !documentsSection.isDataEditable"
                  (update)="onDocumentUpdated($event)"></app-document-editor>
                <div *ngIf="allSampleDocuments?.crane_con_with_electric_drive" class="ui-g-12 sample-doc-link">
                  <label class="ui-g-3"></label>
                  <span class="sample-label">{{ 'documents.sample-label' | translate }}:</span>
                  <a
                    (click)="
                      downloadExampleDocument(
                        allSampleDocuments['crane_con_with_electric_drive'].document_id,
                        allSampleDocuments['crane_con_with_electric_drive'].filename
                      )
                    ">
                    {{ allSampleDocuments['crane_con_with_electric_drive'].name }}
                  </a>
                </div>
              </ng-container>

              <ng-container *ngIf="documents.get('inspection_sticker')">
                <app-document-editor
                  [applicationId]="applicationData?.application_id"
                  [form]="documents"
                  controlName="inspection_sticker"
                  [label]="'documents.inspection_sticker_document' | translate"
                  [documentId]="documentIds['inspection_sticker']"
                  documentType="inspection_sticker"
                  [isReadOnly]="isDetailsView && !documentsSection.isDataEditable"
                  (update)="onDocumentUpdated($event)"></app-document-editor>
                <div *ngIf="allSampleDocuments?.inspection_sticker" class="ui-g-12 sample-doc-link">
                  <label class="ui-g-3"></label>
                  <span class="sample-label">{{ 'documents.sample-label' | translate }}:</span>
                  <a
                    (click)="
                      downloadExampleDocument(
                        allSampleDocuments['inspection_sticker'].document_id,
                        allSampleDocuments['inspection_sticker'].filename
                      )
                    ">
                    {{ allSampleDocuments['inspection_sticker'].name }}
                  </a>
                </div>
              </ng-container>

              <ng-container *ngIf="documents.get('proof_of_landowner')">
                <app-document-editor
                  [applicationId]="applicationData?.application_id"
                  [form]="documents"
                  controlName="proof_of_landowner"
                  [label]="'lookup.' + documentTypeKey + '.options.proof_of_landowner.name' | translate"
                  [documentId]="documentIds['proof_of_landowner']"
                  documentType="proof_of_landowner"
                  [isReadOnly]="isDetailsView && !documentsSection.isDataEditable"
                  (update)="onDocumentUpdated($event)"></app-document-editor>

                <div *ngIf="allSampleDocuments?.proof_of_landowner" class="ui-g-12 sample-doc-link">
                  <label class="ui-g-3"></label>
                  <span class="sample-label">{{ 'documents.sample-label' | translate }}:</span>
                  <a
                    (click)="
                      downloadExampleDocument(
                        allSampleDocuments['proof_of_landowner'].document_id,
                        allSampleDocuments['proof_of_landowner'].filename
                      )
                    ">
                    {{ allSampleDocuments['proof_of_landowner'].name }}
                  </a>
                </div>
              </ng-container>

              <ng-container *ngIf="documents.get('approval_empty_pipe')">
                <app-document-editor
                  [applicationId]="applicationData?.application_id"
                  [form]="documents"
                  controlName="approval_empty_pipe"
                  [label]="'lookup.' + documentTypeKey + '.options.approval_empty_pipe.name' | translate"
                  [documentId]="documentIds['approval_empty_pipe']"
                  documentType="approval_empty_pipe"
                  [isReadOnly]="isDetailsView && !documentsSection.isDataEditable"
                  (update)="onDocumentUpdated($event)"></app-document-editor>

                <div *ngIf="allSampleDocuments?.approval_empty_pipe" class="ui-g-12 sample-doc-link">
                  <label class="ui-g-3"></label>
                  <span class="sample-label">{{ 'documents.sample-label' | translate }}:</span>
                  <a
                    (click)="
                      downloadExampleDocument(
                        allSampleDocuments['approval_empty_pipe'].document_id,
                        allSampleDocuments['approval_empty_pipe'].filename
                      )
                    ">
                    {{ allSampleDocuments['approval_empty_pipe'].name }}
                  </a>
                </div>
              </ng-container>

              <ng-container *ngIf="documents.get('current_account')">
                <app-document-editor
                  [applicationId]="applicationData?.application_id"
                  [form]="documents"
                  controlName="current_account"
                  [label]="'lookup.' + documentTypeKey + '.options.current_account.name' | translate"
                  [documentId]="documentIds['current_account']"
                  [documentType]="'current_account'"
                  [isReadOnly]="isDetailsView && !documentsSection.isDataEditable"
                  (update)="onDocumentUpdated($event)"></app-document-editor>
                <div *ngIf="allSampleDocuments?.current_account" class="ui-g-12 sample-doc-link">
                  <label class="ui-g-3"></label>
                  <span class="sample-label">{{ 'documents.sample-label' | translate }}:</span>
                  <a
                    (click)="
                      downloadExampleDocument(
                        allSampleDocuments['current_account'].document_id,
                        allSampleDocuments['current_account'].filename
                      )
                    ">
                    {{ allSampleDocuments['current_account'].name }}
                  </a>
                </div>
              </ng-container>
            </div>

            <div
              class="form-background top-bottom-margin"
              *ngIf="
                currentInstallationFlow === installationFlowType.ConversionToGas &&
                (showSitePlanDocumentForConversionToGas || showPlanWithEntryForConversionToGas)
              ">
              <app-document-editor
                *ngIf="showSitePlanDocumentForConversionToGas && documents.get('site_plan')"
                [applicationId]="applicationData?.application_id"
                [form]="documents"
                controlName="site_plan"
                [label]="'documents.official-plan' | translate"
                [documentId]="documentIds['site_plan']"
                documentType="site_plan"
                [isReadOnly]="isDetailsView && !documentsSection.isDataEditable"
                (update)="onDocumentUpdated($event)"></app-document-editor>

              <app-document-editor
                *ngIf="showPlanWithEntryForConversionToGas"
                [applicationId]="applicationData?.application_id"
                [form]="documents"
                controlName="floor_plan"
                [label]="'documents.plan_with_entry' | translate"
                [documentId]="documentIds['floor_plan']"
                documentType="floor_plan"
                [isReadOnly]="isDetailsView && !documentsSection.isDataEditable"
                (update)="onDocumentUpdated($event)"></app-document-editor>
            </div>

            <div
              class="form-background top-bottom-margin"
              *ngIf="showExcerptOrOverviewPlanDocument && currentInstallationFlow === installationFlowType.ConversionToGas">
              <app-document-editor
                *ngIf="documents.get('excerpt_or_overview_plan')"
                [applicationId]="applicationData?.application_id"
                [form]="documents"
                controlName="excerpt_or_overview_plan"
                [label]="'documents.excerpt-or-overview-plan' | translate"
                [documentId]="documentIds['excerpt_or_overview_plan']"
                documentType="excerpt_or_overview_plan"
                [isReadOnly]="isDetailsView && !documentsSection.isDataEditable"
                (update)="onDocumentUpdated($event)"></app-document-editor>
              <div
                *ngIf="
                  (currentInstallationFlow === installationFlowType.MainsConnection ||
                    currentInstallationFlow === installationFlowType.ChangeHouseConnection) &&
                  allSampleDocuments?.floor_plan
                "
                class="ui-g-12 sample-doc-link">
                <label class="ui-g-3"></label>
                <span class="sample-label">{{ 'documents.sample-label' | translate }}:</span>
                <a
                  (click)="
                    downloadExampleDocument(
                      allSampleDocuments['excerpt_or_overview_plan'].document_id,
                      allSampleDocuments['excerpt_or_overview_plan'].filename
                    )
                  ">
                  {{ allSampleDocuments['excerpt_or_overview_plan'].name }}
                </a>
              </div>
            </div>

            <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-background" *ngIf="isCustomerPowerAttorneyVisible">
              <app-document-editor
                *ngIf="documents.get('customer_power_of_attorney')"
                [applicationId]="applicationData?.application_id"
                [form]="documents"
                controlName="customer_power_of_attorney"
                [label]="'documents.customer_power_of_attorney' | translate"
                [documentId]="documentIds['customer_power_of_attorney']"
                [documentType]="gridApplicationDocumentTypes.CustomerPowerOfAttorney"
                [isReadOnly]="isDetailsView && !documentsSection.isDataEditable"
                (update)="onDocumentUpdated($event)"></app-document-editor>
            </div>

            <!-- POWER CONSUMER DOCUMENTS -->
            <div class="form-background top-bottom-margin" *ngIf="powerConsumerDocumentDetails?.length">
              <app-document-editor
                *ngFor="let powerConsumerDocument of powerConsumerDocumentDetails"
                [applicationId]="applicationData?.application_id"
                [form]="documents"
                [controlName]="powerConsumerDocument.controlName"
                [label]="'documents.' + powerConsumerDocument.documentType | translate"
                [documentId]="documentIds[powerConsumerDocument.controlName]"
                [documentType]="powerConsumerDocument.documentType"
                [isReadOnly]="isDetailsView && !documentsSection.isDataEditable"
                (update)="onDocumentUpdated($event)"></app-document-editor>
            </div>

            <div class="top-bottom-margin other-docs--container">
              <div *ngFor="let item of items?.controls; let i = index" class="flex-row" formArrayName="items">
                <div [formGroupName]="i">
                  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
                    <div class="ui-g-3 ui-xl-3 ui-lg-3 ui-md-4 ui-sm-12 ui-xs-12 field-label text-right-align mr-8">
                      <input *ngIf="!item?.value?.fileName" class="doc-name-input" formControlName="documentName" pInputText type="text" />
                      <label *ngIf="item?.value?.fileName" class="doc-name-label">{{ item.get('documentName').value }}</label>
                    </div>
                    <div class="ui-g-9 ui-xl-9 ui-lg-9 ui-md-9 ui-sm-12 controls">
                      <input class="doc-submit-inputs" [value]="item?.value['fileName']" disabled pInputText type="text" />
                      <p-fileUpload
                        *ngIf="documentsSection.isDataEditable"
                        #documentUploader
                        (onSelect)="onImageUpload($event, i, documentUploader)"
                        chooseLabel="{{ 'facilities-data.form-fields.upload-button' | translate }}"
                        mode="basic"></p-fileUpload>

                      <button
                        *ngIf="item.value['fileName']"
                        (click)="downloadDocument(i, item.value['fileName'])"
                        icon="pi pi-download"
                        pButton
                        type="button"
                        class="btn-download ui-fileupload-choose"
                        [label]="'download-button-label' | translate"></button>

                      <div class="file-name-section">
                        <i
                          *ngIf="documentsSection.isDataEditable"
                          (click)="removeDocument(i)"
                          class="pi pi-trash pointer-cursor delete-icon btn-delete-file"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12" *ngIf="documentsSection.isDataEditable">
                <div class="ui-g-12 margin-align add-button-row form-font-size">
                  <i
                    (click)="addDocuments(true)"
                    class="pi pi-plus plus-icon new-facility-plus-icon"
                    id="add-document-button"
                    tabindex="0"
                    appEnterClick></i>
                  <label class="ui-g-5 field-label" for="add-document-button">
                    {{ 'facilities-data.form-fields.add-document-button' | translate }}
                  </label>
                </div>
              </div>
            </div>

            <div
              class="hint-text"
              *ngIf="showNoteFindRelevantDocsChecklist && currentInstallationFlow === installationFlowType.FeedInSystem">
              {{ 'documents.find-document-checklist' | translate }}
            </div>
            <div class="hint-text" *ngIf="showNoteUploadAltMeasurementDoc">
              {{ 'documents.upload-alternative-measurement-document' | translate }}
            </div>
            <div *ngIf="currentInstallationFlow === installationFlowType.FeedInSystem && showNoteIfStorageIsSelected" class="hint-text">
              {{ 'documents.note-if-storage-is-selected' | translate }}
            </div>

            <div class="ordnance-warning" *ngIf="showHelpText">
              <i class="pi pi-exclamation-circle info-icon"></i>
              <span [innerHTML]="'documents.help-text' | translate"></span>
            </div>

            <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12">
              <ng-content select="after-documents"></ng-content>
            </div>

            <div
              class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 comment-section"
              *ngIf="
                currentInstallationFlow === installationFlowType.FeedInSystem ||
                currentInstallationFlow === installationFlowType.MainsConnection ||
                currentInstallationFlow === installationFlowType.TemporaryConnection ||
                currentInstallationFlow === installationFlowType.ChangeHouseConnection ||
                currentInstallationFlow === installationFlowType.ConversionToGas ||
                currentInstallationFlow === installationFlowType.ConsumptionDevices ||
                showCommentField
              ">
              <div class="ui-g-12 comment-section-title">{{ 'documents.comment' | translate }}</div>
              <ng-container *ngIf="environmentService.showWordFormat && documents.get('comments')">
                <quill-editor
                  #editor1
                  [readOnly]="isDetailsView"
                  [styles]="editorStyle"
                  placeholder="Enter Text"
                  formControlName="comments"
                  [modules]="quillConfig"></quill-editor>
              </ng-container>
              <ng-container *ngIf="!environmentService.showWordFormat && documents.get('comments')">
                <textarea
                  *ngIf="!isDetailsView"
                  rows="10"
                  class="ui-g-12 comments-container"
                  formControlName="comments"
                  pInputTextarea
                  [maxlength]="maxCommentLength"></textarea>
                <div *ngIf="isDetailsView" rows="10" class="ui-g-12 comments-container">{{ documents.get('comments')?.value }}</div>
              </ng-container>
            </div>
          </div>
        </app-review-section>
      </div>

      <form
        class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align"
        *ngIf="showContactPersonOnDocumentsPage && documents">
        <app-contact-person
          [isDetailsView]="isDetailsView"
          (initForm)="onContactPersonInit($event)"
          [applicationId]="applicationData?.application_id"
          [data]="contactPersonData"></app-contact-person>
      </form>

      <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
        <app-review-section
          #inquirySection
          *ngIf="showInquiry && applicationData"
          [title]="'basic-profile.jurisdiction.inquiry' | translate"
          [tooltip]="'tooltips.documents-submission.jurisdiction.inquiry' | translate"
          [isDetailsView]="isDetailsView"
          [applicationId]="applicationData.application_id"
          [sectionId]="SectionIdentifier.Document_Inquiry"></app-review-section>
        <div
          *ngIf="
            showInquiry &&
            (showConnectionDateSelector ||
              (currentInstallationFlow === installationFlowType.TemporaryConnection && !showInquiryDesiredDate))
          "
          class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 top-margin">
          <div class="ui-g-5 ui-xl-5 ui-lg-5 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
            <label class="ui-g-3 field-label text-right-align margin-right-align" for="doc-sub-des-date">
              {{ 'documents.building_conn_date' | translate }}
            </label>
            <p-calendar
              tabIndex="0"
              appCalendarEscapeClose
              *ngIf="'app.calendar-settings' | translate"
              [(ngModel)]="connectionDate"
              [dateFormat]="dateFormat.dateFormat"
              [monthNavigator]="true"
              [locale]="'app.calendar-settings' | translate"
              [placeholder]="dateFormat.placeholder"
              [yearNavigator]="true"
              [disabled]="isDetailsView"
              class="doc-submit-datepicker ui-g-7"
              dataType="string"
              id="building-conn-date"
              inputId="basic"
              [minDate]="minBuildingConDate"
              yearRange="1900:2080"></p-calendar>
            <div
              *ngIf="
                showWorksBeginsAfterOfferLable &&
                (currentInstallationFlow === installationFlowType.MainsConnection ||
                  currentInstallationFlow === installationFlowType.ConversionToGas)
              ">
              {{ 'documents.works-begins-14-weeks-after-offer' | translate }}
            </div>
          </div>
        </div>
        <div
          class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows top-margin"
          *ngIf="
            showInquiry &&
            (currentInstallationFlow !== installationFlowType.TemporaryConnection ||
              (currentInstallationFlow === installationFlowType.TemporaryConnection && showInquiryDesiredDate))
          ">
          <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-right-align">
            <label class="ui-g-4 field-label text-right-align margin-right-align" for="doc-sub-des-date">
              {{ 'facilities-data.form-fields.des_date' | translate }}
            </label>
            <p-calendar
              tabIndex="0"
              appCalendarEscapeClose
              *ngIf="'app.calendar-settings' | translate"
              [(ngModel)]="selectedDate"
              [dateFormat]="dateFormat?.dateFormat"
              [monthNavigator]="true"
              [locale]="'app.calendar-settings' | translate"
              [placeholder]="dateFormat?.placeholder"
              [yearNavigator]="true"
              [disabled]="isDetailsView && !inquirySection?.isDataEditable"
              class="doc-submit-datepicker ui-g-7"
              dataType="string"
              id="doc-sub-des-date"
              inputId="basic"
              [minDate]="minDate"
              [defaultDate]="minDate"
              [disabledDays]="selectedDateDisabledDays"
              yearRange="1900:2080"></p-calendar>
            <i
              class="pi pi-info-circle hint-icon ml-10"
              *ngIf="infoBubblesData?.showInquiryInfo"
              tooltipStyleClass="netz-info-tooltip"
              pTooltip="{{
                (showDesiredDateOperationInfo ? 'documents.desired-date-operation-info' : 'documents.desired-date-inquiry') | translate
              }}"></i>
          </div>
          <div
            *ngIf="
              showWorksBeginsAfterOfferLable &&
              (currentInstallationFlow === installationFlowType.MainsConnection ||
                currentInstallationFlow === installationFlowType.ConversionToGas)
            ">
            {{ 'documents.works-begins-14-weeks-after-offer' | translate }}
          </div>
          <div
            class="ui-g-5 ui-xl-5 ui-lg-5 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align chimney-container"
            [formGroup]="documents"
            *ngIf="documents?.get('chimneySweep')">
            <label
              class="ui-g-4 field-label text-right-align margin"
              [class.required]="documents?.get('chimneySweep')"
              for="chimney-sweeper">
              {{ 'documents.chimney_sweepers' | translate }}
            </label>
            <p-dropdown
              [options]="chimneySweeperOptions"
              [disabled]="isDetailsView"
              formControlName="chimneySweep"
              id="chimney-sweeper"
              placeholder="-Select-"
              optionLabel="name"
              optionValue="chimney_sweeper_id"></p-dropdown>
          </div>
        </div>
        <div
          class="p-field-checkbox align-label"
          *ngIf="
            !isDetailsView &&
            showCorrectnessOfInformationCheckbox &&
            (currentInstallationFlow === installationFlowType.MainsConnection ||
              currentInstallationFlow === installationFlowType.ConversionToGas)
          ">
          <p-checkbox
            appEnterClick
            binary="true"
            inputId="binary"
            [(ngModel)]="correctnessOfInformationCheckbox"
            (onChange)="checkValidityForSubmitButton()"></p-checkbox>
          <label class="required">{{ 'documents.correctness-of-information' | translate }}</label>
        </div>

        <div
          class="mains-connection-approval-section ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12"
          *ngIf="!isDetailsView && currentInstallationFlow === installationFlowType.MainsConnection && showMainsConnectionApproval">
          <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 top-bottom-margin">
            <h3 *ngIf="role === 'customer'; else technicianGuestTechnicianHeader">
              {{ 'documents.prerequisites-for-completing.headline' | translate }}
            </h3>
            <ng-template #technicianGuestTechnicianHeader>
              <h3>{{ 'documents.prerequisites-for-completing.technician-guest-technician-headline' | translate }}</h3>
            </ng-template>
            <div *ngIf="role === 'customer'; else technicianGuestTechnicianCondition" class="p-field-checkbox align-label">
              <p-checkbox
                appEnterClick
                binary="true"
                inputId="binary"
                [(ngModel)]="gridConnectionContractCheckbox"
                (onChange)="checkValidityForSubmitButton()"></p-checkbox>
              <label class="required">{{ 'documents.prerequisites-for-completing.condition-1' | translate }}</label>
            </div>
            <ng-template #technicianGuestTechnicianCondition>
              <div class="p-field-checkbox align-label">
                <p-checkbox
                  appEnterClick
                  binary="true"
                  inputId="binary"
                  [(ngModel)]="isVerifiedByTechnician"
                  (onChange)="checkValidityForSubmitButton()"></p-checkbox>
                <label class="required">
                  {{ 'documents.prerequisites-for-completing.technician-guest-technician-condition-1' | translate }}
                </label>
              </div>
            </ng-template>
            <ng-container *ngIf="role === 'customer'">
              <div class="p-field-checkbox align-label">
                <p-checkbox
                  appEnterClick
                  binary="true"
                  inputId="binary"
                  [(ngModel)]="buildingIsClosedCheckbox"
                  (onChange)="checkValidityForSubmitButton()"></p-checkbox>
                <label class="required">{{ 'documents.prerequisites-for-completing.condition-2' | translate }}</label>
              </div>
              <div class="p-field-checkbox align-label">
                <p-checkbox
                  appEnterClick
                  binary="true"
                  inputId="binary"
                  [(ngModel)]="freedomToBuildCheckbox"
                  (onChange)="checkValidityForSubmitButton()"></p-checkbox>
                <label class="required">{{ 'documents.prerequisites-for-completing.condition-3' | translate }}</label>
              </div>
              <div class="p-field-checkbox align-label">
                <p-checkbox
                  appEnterClick
                  binary="true"
                  inputId="binary"
                  [(ngModel)]="sewageAndRainwaterClosureCheckbox"
                  (onChange)="checkValidityForSubmitButton()"></p-checkbox>
                <label class="required">{{ 'documents.prerequisites-for-completing.condition-4' | translate }}</label>
              </div>
              <div class="p-field-checkbox align-label">
                <p-checkbox
                  appEnterClick
                  binary="true"
                  inputId="binary"
                  [(ngModel)]="houseEntriesCheckbox"
                  (onChange)="checkValidityForSubmitButton()"></p-checkbox>
                <label class="required">{{ 'documents.prerequisites-for-completing.condition-5' | translate }}</label>
              </div>
            </ng-container>
          </div>
        </div>

        <div
          class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 top-bottom-margin"
          *ngIf="
            !isDetailsView &&
            isHeatingFacilityAvailable &&
            currentInstallationFlow === installationFlowType.MainsConnection &&
            showDistrictHeatingRegulationsCheckbox
          ">
          <div class="p-field-checkbox align-label">
            <p-checkbox
              appEnterClick
              binary="true"
              inputId="binary"
              [(ngModel)]="districtHeatingRegulationsChecked"
              (onChange)="checkValidityForSubmitButton()"></p-checkbox>
            <label class="required">{{ 'documents.terms-for-heating.condition-3' | translate }}</label>
          </div>
        </div>

        <div
          class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 top-bottom-margin"
          *ngIf="
            isPowerFacilityAvailable &&
            (currentInstallationFlow === installationFlowType.NewInstallation ||
              (currentInstallationFlow === installationFlowType.UpdateInstallation && showPowerTermsChecked) ||
              currentInstallationFlow === installationFlowType.SiteElectricityMeterdata)
          ">
          <div class="p-field-checkbox">
            <p-checkbox
              [disabled]="isDetailsView"
              appEnterClick
              binary="true"
              inputId="binary"
              [(ngModel)]="powerTermsChecked"
              (onChange)="checkValidityForSubmitButton()"></p-checkbox>
            <label>{{ 'documents.terms-for-power' | translate }}</label>
          </div>
        </div>
        <div
          class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 top-bottom-margin"
          *ngIf="
            !isDetailsView &&
            isAllMediaFacilityAvailable &&
            (currentInstallationFlow === installationFlowType.MainsConnection ||
              currentInstallationFlow === installationFlowType.ChangeHouseConnection) &&
            showTechnicalConditionsMetCheckbox
          ">
          <div class="p-field-checkbox">
            <p-checkbox
              appEnterClick
              binary="true"
              inputId="binary"
              [(ngModel)]="technicalConditionsMetCheckbox"
              (onChange)="checkValidityForSubmitButton()"></p-checkbox>
            <label>{{ 'documents.terms-for-all-media' | translate }}</label>
          </div>
        </div>
        <div
          class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 top-bottom-margin"
          *ngIf="!isDetailsView && currentInstallationFlow === installationFlowType.MainsConnection && showAcceptOfferCheckbox">
          <div class="p-field-checkbox">
            <p-checkbox
              appEnterClick
              binary="true"
              inputId="binary"
              [(ngModel)]="acceptOfferCheckbox"
              (onChange)="checkValidityForSubmitButton()"></p-checkbox>
            <label>{{ 'documents.accept-offer-agreement' | translate }}</label>
          </div>
        </div>
        <div
          class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 top-bottom-margin"
          *ngIf="
            !isDetailsView &&
            isGasFacilityAvailable &&
            (currentInstallationFlow === installationFlowType.NewInstallation ||
              currentInstallationFlow === installationFlowType.UpdateInstallation)
          ">
          <div class="p-field-checkbox">
            <p-checkbox
              appEnterClick
              binary="true"
              inputId="binary"
              [(ngModel)]="gasTermsChecked1"
              (onChange)="checkValidityForSubmitButton()"></p-checkbox>
            <label>{{ 'documents.terms-for-gas1' | translate }}</label>
          </div>
          <div class="p-field-checkbox">
            <p-checkbox
              appEnterClick
              binary="true"
              inputId="binary"
              [(ngModel)]="gasTermsChecked2"
              (onChange)="checkValidityForSubmitButton()"></p-checkbox>
            <label>{{ 'documents.terms-for-gas2' | translate }}</label>
          </div>
          <div class="p-field-checkbox" *ngIf="environmentService.showGas3">
            <p-checkbox
              appEnterClick
              binary="true"
              inputId="binary"
              [(ngModel)]="gasTermsChecked3"
              (onChange)="checkValidityForSubmitButton()"></p-checkbox>
            <label>
              <b>{{ 'documents.terms-for-gas3' | translate }}</b>
            </label>
          </div>
        </div>
        <div
          class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 top-bottom-margin"
          *ngIf="!isDetailsView && isWaterFacilityAvailable && currentInstallationFlow === installationFlowType.NewInstallation">
          <div class="p-field-checkbox">
            <p-checkbox
              appEnterClick
              binary="true"
              inputId="binary"
              [(ngModel)]="waterTermsChecked"
              (onChange)="checkValidityForSubmitButton()"></p-checkbox>
            <label class="terms-labels">
              {{ 'documents.condition-start' | translate }}
              <ul>
                <li>{{ 'documents.terms-for-water.condition-1' | translate }}</li>
                <li>{{ 'documents.terms-for-water.condition-2' | translate }}</li>
                <li>{{ 'documents.terms-for-water.condition-3' | translate }}</li>
                <li>{{ 'documents.terms-for-water.condition-4' | translate }}</li>
              </ul>
            </label>
          </div>
        </div>
        <div
          class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 top-bottom-margin"
          *ngIf="!isDetailsView && isHeatingFacilityAvailable && currentInstallationFlow === installationFlowType.NewInstallation">
          <div class="p-field-checkbox">
            <p-checkbox
              appEnterClick
              binary="true"
              inputId="binary"
              [(ngModel)]="heatingTermsChecked"
              (onChange)="checkValidityForSubmitButton()"></p-checkbox>
            <label class="terms-labels">
              <ul>
                <li>{{ 'documents.terms-for-heating.condition-1' | translate }}</li>
                <li>{{ 'documents.terms-for-heating.condition-2' | translate }}</li>
              </ul>
            </label>
          </div>
        </div>

        <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12" [formGroup]="documents" *ngIf="documents">
          <div
            class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 comment-section"
            *ngIf="showInstallationComment && documents?.get('installationComment')">
            <div class="ui-g-12 comment-section-title">{{ 'documents.additional-comment' | translate }}</div>
            <ng-container *ngIf="environmentService.showWordFormat && documents.get('installationComment')">
              <quill-editor
                #editor2
                [readOnly]="isDetailsView"
                [styles]="editorStyle"
                placeholder="Enter Text"
                formControlName="installationComment"
                [modules]="quillConfig"></quill-editor>
            </ng-container>
            <ng-container *ngIf="!environmentService.showWordFormat && documents.get('installationComment')">
              <textarea
                *ngIf="!isDetailsView"
                rows="10"
                class="ui-g-12 comments-container"
                formControlName="installationComment"
                pInputTextarea
                [maxlength]="maxCommentLength"></textarea>
              <div *ngIf="isDetailsView" rows="10" class="ui-g-12 comments-container">
                {{ documents.get('installationComment')?.value }}
              </div>
            </ng-container>
          </div>
        </div>
        <div
          class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 top-margin submit-button-section"
          *ngIf="!isDetailsView && showSubmitButton">
          <div class="add-more-prod" *ngIf="showAddMoreProductsButton">
            <i
              class="pi pi-shopping-cart add-more-prod-icon"
              [ngClass]="isSubmitDisabled ? 'add-more-prod-icon-disabled' : ''"
              pTooltip="{{ 'documents.add-more-prod' | translate }}"
              (click)="redirectToProducts()"></i>
          </div>
          <button
            (click)="submitFormData(false)"
            class="submit-button text-uppercase"
            label="{{ 'basic-profile.fields.send_request' | translate }}"
            pButton
            [disabled]="isSubmitDisabled"
            type="button"></button>
        </div>
      </div>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="environmentService.isDecommissioningOfGridConnection && currentSelectionType === 'shutdown'">
  <div>
    <p class="submit-success-text">
      {{ 'submitted.no_document_needed' | translate }}
    </p>
  </div>
  <div
    *ngIf="showSubmitButton"
    class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 top-margin"
    [ngClass]="
      environmentService.isDecommissioningOfGridConnection && currentSelectionType === 'shutdown'
        ? 'submit-button-decommission'
        : 'submit-button-section'
    ">
    <button
      (click)="submitFormData(false)"
      class="submit-button text-uppercase"
      label="{{ 'basic-profile.fields.send_request' | translate }}"
      pButton
      type="button"></button>
  </div>
</ng-container>
<app-loader *ngIf="isLoading"></app-loader>
